import React from 'react';
import { industryNetwork } from '../data/corporateData';
import { Network, MapPin } from 'lucide-react';

const IndustryNetwork = () => {
  return (
    <section className="py-16 sm:py-24 bg-[#0A192F]" id="network">
      <div className="container mx-auto px-4 sm:px-8 lg:px-16">
        {/* Section Header */}
        <div className="mb-12 max-w-3xl">
          <span className="text-xs font-bold tracking-[0.2em] uppercase text-rose-500 font-heading mb-4 block">
            Strategic Partnerships
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white mb-4 font-heading">
            {industryNetwork.title}
          </h2>
          <p className="text-base text-slate-300 leading-relaxed font-body">
            {industryNetwork.description}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-testid="industry-network">
          {/* Partnership Categories */}
          <div className="space-y-6">
            {industryNetwork.categories.map((category) => (
              <div
                key={category.id}
                className="bg-[#112240] border border-white/10 rounded-lg p-6"
                data-testid={`network-category-${category.id}`}
              >
                <div className="flex items-center gap-3 mb-4">
                  <Network className="text-rose-500" size={20} />
                  <h3 className="text-lg font-semibold text-white font-heading">
                    {category.name}
                  </h3>
                </div>
                <div className="flex flex-wrap gap-2">
                  {category.partners.map((partner, idx) => (
                    <span
                      key={`${category.id}-${idx}`}
                      className="px-3 py-1 bg-rose-500/10 border border-rose-500/30 rounded-full text-xs text-slate-300 font-body"
                    >
                      {partner}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Market Footprint */}
          <div className="bg-[#112240] border border-white/10 rounded-lg p-6">
            <h3 className="text-lg font-semibold text-white mb-6 font-heading">
              Global Market Footprint
            </h3>
            <div className="space-y-4">
              {industryNetwork.marketFootprint.map((market) => (
                <div
                  key={market.id}
                  className="flex items-start gap-4 p-4 bg-[#0A192F]/50 rounded-lg border border-white/5 hover:border-rose-500/30 transition-colors duration-300"
                  data-testid={`market-${market.id}`}
                >
                  <MapPin className="text-rose-500 flex-shrink-0 mt-1" size={20} />
                  <div>
                    <div className="text-base font-semibold text-white mb-1 font-heading">
                      {market.region}
                    </div>
                    <div className="text-sm text-slate-400 font-body">
                      {market.role}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustryNetwork;
